// Best-effort platform detection for keyboard-shortcut hints (⌘ vs Ctrl).
// SSR-safe and non-critical: a wrong guess only changes a displayed glyph.
export const isMac: boolean =
  typeof navigator !== 'undefined' &&
  /Mac|iPhone|iPad|iPod/i.test(navigator.platform || navigator.userAgent || '');
